import React, { Component } from "react";

import Select from "react-select";

import { Button } from "aible";
import { LineInput } from "components/Inputs/LineInput";

import styles from "./style.module.css";

export default class OptimierCreator extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      firstDataset,
      secondDataset,
      optimizers,
      history,
      handleCreate,
      updateFirstRunId,
      updateSecondRunId,
      updateOverallColumn,
      updateFirstColumn,
      updateSecondColumn
    } = this.props;

    const matchingColumns =
      firstDataset && secondDataset && firstDataset.fields
        ? Object.keys(firstDataset.fields)
            .filter((f) => firstDataset.fields[f].data)
            .filter((f) => secondDataset.fields[f])
            .map((f) => ({ label: f, value: f }))
        : [];

    return (
      <div className={styles.optimizer}>
        <div className={styles.optimizerCreator}>
          <div className={styles.create}>
            <div className={styles.bold} style={{ marginBottom: "10px" }}>
              {"Create New Optimizer"}
            </div>
            <div className={styles.creatorSection}>
              <div className={styles.bold}>{"Marketing Run ID:"}</div>
              <LineInput isMediumBox onChange={(val) => updateFirstRunId(val)} />
            </div>
            <div className={styles.creatorSection}>
              <div className={styles.bold}>{"Sales Run ID:"}</div>
              <LineInput isMediumBox onChange={(val) => updateSecondRunId(val)} />
            </div>
            <div className={styles.creatorSection}>
              <div className={styles.bold}>{"Region Column"}</div>
              <Select
                onChange={(val) => updateOverallColumn(val.value)}
                options={matchingColumns}
                placeholder={firstDataset && secondDataset ? "Select Column" : "Choose Datasets"}
              />
            </div>
            <div className={styles.creatorSection}>
              <div className={styles.bold}>{"Marketing Column"}</div>
              <Select
                onChange={(val) => updateFirstColumn(val.value)}
                options={
                  firstDataset && firstDataset.fields
                    ? Object.keys(firstDataset.fields)
                        .filter((f) => firstDataset.fields[f].data)
                        .map((f) => ({
                          label: f,
                          value: f
                        }))
                    : []
                }
                placeholder={firstDataset ? "Select Column" : "Choose Dataset"}
              />
            </div>
            <div className={styles.creatorSection}>
              <div className={styles.bold}>{"Sales Column"}</div>
              <Select
                onChange={(val) => updateSecondColumn(val.value)}
                options={
                  secondDataset && secondDataset.fields
                    ? Object.keys(secondDataset.fields)
                        .filter((f) => secondDataset.fields[f].data)
                        .map((f) => ({
                          label: f,
                          value: f
                        }))
                    : []
                }
                placeholder={secondDataset ? "Select Column" : "Choose Dataset"}
              />
            </div>
            <Button onClick={() => handleCreate()} style={{ marginTop: "10px" }}>
              {"Create"}
            </Button>
          </div>
          <div className={styles.cList}>
            <div className={styles.bold} style={{ marginBottom: "10px" }}>
              {"Previous Optimizers"}
            </div>
            {optimizers &&
              optimizers.map((o, i) => (
                <div key={i}>
                  <a onClick={() => history.push("optimizer/" + o.firstRunId + "/" + o.secondRunId)}>
                    {"Marketing: " + o.firstRunId + " / Sales: " + o.secondRunId}
                  </a>
                </div>
              ))}
          </div>
        </div>
      </div>
    );
  }
}
